import { render, staticRenderFns } from "./TalentProfile.vue?vue&type=template&id=610f73a4&scoped=true"
import script from "./TalentProfile.vue?vue&type=script&lang=js"
export * from "./TalentProfile.vue?vue&type=script&lang=js"
import style0 from "./TalentProfile.vue?vue&type=style&index=0&id=610f73a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610f73a4",
  null
  
)

export default component.exports